import styled, { css } from 'styled-components';
import { Button } from 'src/components/button';
import { media } from 'src/components/base';

export const ToggleVisibilityButton = styled(Button)<{ chip?: boolean }>`
  width: 100;
  ${media.largeUp`
    width: auto;
    borderRadius: 20px;
    padding: 2px 5px 2px 10px;
  `}
  ${() => css`
    width: 'auto',
    borderRadius: '20px',
    padding: '2px 5px 2px 10px',
  `}
`;
